import React from "react";
import "../css/ChatbotIcon.css"; // Import the CSS file for styling

import ChatbotIconPNG from "../images/ChatBotIcon.png"; // Import the image for the Chatbot icon

const ChatbotIcon = () => {
  return (
    <a
      href="https://dzb28dty6bryq.cloudfront.net/index.html"
      className="chatbot-icon"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={ChatbotIconPNG} alt="Chatbot" className="chatbot-icon-img" />
    </a>
  );
};

export default ChatbotIcon;